import React from 'react'
import { useState } from 'react'

export default function Header() {
	const [hovered, setHovered] = useState(false)
	const handleMouseEnter = () => {
		setHovered(true)
	}
	const handleMouseLeave = () => {
		setHovered(false)
	}

	return (
		<div
			data-animation="default"
			data-collapse="medium"
			data-duration={400}
			data-easing="ease"
			data-easing2="ease"
			role="banner"
			className="nav-bar w-nav">
			<div className="container-main w-container">
				<div className="navbar-wrap">
					<a
						href="/"
						aria-current="page"
						className="brand w-nav-brand w--current">
						{/* <h3 className="nav-brand-h4">metamates ape lounge</h3> */}
					</a>
					<nav role="navigation" className="nav-menu w-nav-menu">
						<a href="#fire-pit" className="nav-link w-nav-link"></a>
						<a href="#roadmap" className="nav-link w-nav-link">
							Roadmap
						</a>
						<a href="#faq" className="nav-link w-nav-link">
							FAQ
						</a>
						<a href="#team" className="nav-link w-nav-link">
							Team
						</a>
						<div
							className="btn-group"
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}>
							<button className="hero-cta cus-btn">Connect Wallet</button>
							<div
								className="btn-menu"
								style={{ display: hovered ? 'block' : 'none' }}>
								<div className="container">
									<ul className="btn-menu-list">
										<li className="btn-menu-item active">
											<img src="assets/images/arrow_right.svg" alt="" />
											MetaMask
										</li>
										<li className="btn-menu-item">
											<img src="assets/images/arrow_right.svg" alt="" /> 
											Phantom
										</li>
									</ul>
								</div>
							</div>
						</div>
					</nav>
					<div className="menu-button w-nav-button">
						<div className="w-icon-nav-menu" />
					</div>
				</div>
			</div>
		</div>
	)
}
